"use strict";
exports.__esModule = true;
exports.toMediaTypePrismic = exports.toMediaType = exports.MEDIA_TYPE_PRISMIC_TO_LGLP = void 0;
var ramda_1 = require("ramda");
var types_1 = require("../../types");
exports.MEDIA_TYPE_PRISMIC_TO_LGLP = {
    Infographie: types_1.MediaType.Infographic,
    'Dossier de presse': types_1.MediaType.Communication,
    'Communiqué de presse': types_1.MediaType.Release,
    Photo: types_1.MediaType.Photo,
    Vidéo: types_1.MediaType.Video,
    Audio: types_1.MediaType.Audio,
    Publication: types_1.MediaType.Publication
};
var toMediaType = function (prismicMediaType, logger) {
    return logger.toConstValue(prismicMediaType, exports.MEDIA_TYPE_PRISMIC_TO_LGLP);
};
exports.toMediaType = toMediaType;
var toMediaTypePrismic = function (mediaType, logger) {
    return logger.toConstValue(mediaType, ramda_1.invertObj(exports.MEDIA_TYPE_PRISMIC_TO_LGLP));
};
exports.toMediaTypePrismic = toMediaTypePrismic;
//# sourceMappingURL=media-type.js.map